// extracted by mini-css-extract-plugin
export default {"splineContainer":"SpaceScene_splineContainer__wpLrM"};